import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, kmFormatter } from "../utils";
import "./SubTopicWisePlatformAnalysis.scss";

class SubTopicWisePlatformAnalysisChart extends PureComponent {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
    }
    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.expandWidget !== this.props.expandWidget && this.props.expandWidget === true) {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        }
    }
    componentWillUnmount() {
        this.ro.disconnect();
    }
    getBarOptions = () => {
        let chartConfig = {};
        let data = JSON.parse(JSON.stringify(this.props.data));
        let self = this;
        let chartData;
        if (this.props.expandWidget) {
            chartData = JSON.parse(JSON.stringify(data.maximizeStackedBarData));
        } else {
            chartData = JSON.parse(JSON.stringify(data.chartDataBar));
        }
        // console.log("firsthello", chartData);
        let offsetHeight = this.props.expandWidget ? 70 : 230;

        chartConfig = {
            chart: {
                type: "bar",
                className: "skiptranslate",
                events: {},
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                    width: "100%",
                },
                // backgroundColor: this.props.expandWidget ? "" : "transparent",
                backgroundColor: "transparent",
                scrollablePlotArea: {
                    opacity: 1,
                    // width: "100%",
                    minHeight:
                        this.props.expandWidget && data.maximizeStackedBarData[0].data.length > 20
                            ? data.maximizeStackedBarData[0].data.length * 30
                            : data.chartDataBar[0].data.length,
                },
            },
            title: {
                text: ``,
            },
            credits: {
                enabled: false,
            },
            xAxis: {
                type: "category",
                lineWidth: 1,
                labels: {
                    formatter: function () {
                        let label = null;
                        if (this.value !== "Others") {
                            let text = this.chart.userOptions.series[0].data.find((ele) => ele.subtopicId[0] == this.value);
                            label = text.main_subtopic_name?.length > 25 ? text.main_subtopic_name.substring(0, 24) + "..." : text.main_subtopic_name;
                        } else {
                            label = "Others";
                        }
                        return label;
                    },
                    // events: {
                    //     mouseover: function (e) {
                    //         console.log(e, e.x, e.y, this);
                    //         let label = "";
                    //         if (this.value != "Others") {
                    //             label = this.chart.userOptions.series[0].data.find((ele) => ele.subtopicId[0] == this.axis.names[this.pos]);
                    //         } else {
                    //             label = {};
                    //             label.main_subtopic_name = "Others";
                    //         }
                    //         const chart = this.chart;
                    //         chart.myLabel = chart.renderer
                    //             .label(label.main_subtopic_name, 180, e.y - offsetHeight, "rectangle")
                    //             .css({
                    //                 color: "#FFFFFF",
                    //                 position: "relative",
                    //                 top: `${e.y}px`,
                    //                 left: `${e.x - 150}px`,
                    //                 opacity: 1,
                    //             })
                    //             .attr({
                    //                 fill: "rgba(0, 0, 0, 1)",
                    //                 backgroundColor: "#000",
                    //                 padding: 8,
                    //                 zIndex: 99999999999,
                    //                 r: 4,
                    //                 t: 40,
                    //                 b: 0,
                    //             })
                    //             .add();
                    //         // .toFront();
                    //     },
                    //     mouseout: function (e) {
                    //         const chart = this.chart;
                    //         if (chart.myLabel) {
                    //             chart.myLabel.destroy();
                    //         }
                    //     },
                    // },
                },
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: 0,
                max: 100,
                reversedStacks: false,
                title: {
                    text: ``,
                },
                labels: {
                    format: "{text}%",
                },
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    stacking: "percent",
                    minPointLength: 10,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        formatter: function () {
                            if (this.y && this.point.options.subtopic_total > 0) {
                                return kmFormatter(this.y);
                            } else if (this.point.options.subtopic_total === 0) {
                                return kmFormatter(this.y);
                            }
                        },

                        x: 10,
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.showLegend,
                alignColumns: true,
                width: "20%",
                layout: "vertical",
                align: "right",
                padding: 3,
                itemMarginTop: 3,
                itemMarginBottom: 3,
                verticalAlign: "middle",
                itemStyle: {
                    fontWeight: 500,
                    textTransform: "normal",
                    fontFamily: "'Roboto', sans-serif",
                    opacity: 0.7,
                    zIndex: -1,
                },
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            series: chartData,
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                shared: true,
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                useHTML: true,
                shadow: false,
                headerFormat: `<span style="display:block;margin-bottom:5px"><b>{point.point.main_subtopic_name}</b></span>`,
                padding: 10,
                opacity: 1,
                outside: true,
                style: {
                    zIndex: 200000,
                    opacity: 1,
                    backgroundColor: "#ff6633",
                },
                // width: 800,
                pointFormatter: function () {
                    let toolTipData = ``;
                    let topicTotal = this.options.subtopic_total;
                    if (topicTotal != 0 && this.y != 0) {
                        toolTipData += `<span style="border:0px solid gray;display:block;border-radius:4px;width:300px;padding:0px 1px;"><span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;"> <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${
                            this.series.color
                        };border-radius:10px" ></span> <span style="display:inline-block;width:114px;">${
                            this.series.name
                        } </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                            ((this.y * 100) / topicTotal).toFixed(1) + "%"
                        }</b> </span> <span style="display:inline-block;padding:1px"><b>(${numberWithCommas(this.y)} / ${numberWithCommas(
                            topicTotal,
                        )})</b> </span><br/> </span>`;
                    }
                    return toolTipData;
                },
            },
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                labelFormatter: function () {
                                    let name = this.name.length > 12 ? this.name.substring(0, 12) + "..." : this.name;
                                    return name;
                                },
                            },
                            xAxis: {
                                labels: {
                                    formatter: function () {
                                        let label = null;
                                        if (this.value !== "Others") {
                                            let text = this.chart.userOptions.series[0].data.find((ele) => ele.subtopicId[0] == this.value);
                                            label =
                                                text.main_subtopic_name?.length > 25
                                                    ? text.main_subtopic_name.substring(0, 24) + "..."
                                                    : text.main_subtopic_name;
                                        } else {
                                            label = "Others";
                                        }
                                        return label;
                                    },
                                },
                            },
                        },
                    },
                ],
            },
        };
        return chartConfig;
    };

    render() {
        return (
            <>
                {this.props.currentChartType === "bar" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getBarOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "calc(100% - 0px)" } }}
                    />
                )}
            </>
        );
    }
}
export default SubTopicWisePlatformAnalysisChart;
